import React from 'react';

interface AnnotationSaveModalProps {
    onClose: () => void;
    onOkay: () => void;
    message?: string;
}

const AnnotationSaveModal: React.FC<AnnotationSaveModalProps> = ({
    onClose,
    onOkay,
    message = 'Are you sure want to save it?',
}) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[25rem]">
                <p className="text-center text-gray-800">{message}</p>
                <div className="flex justify-end space-x-4 mt-4">
                    <button
                        data-testid="annotation-save-modal-cancel-button"
                        className="px-4 py-2 bg-white rounded-3xl hover:bg-gray-400 border border-blue-600"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        data-testid="annotation-save-modal-ok-button"
                        className="px-4 py-2 bg-blue-500 text-white rounded-3xl hover:bg-blue-600"
                        onClick={onOkay}
                    >
                        Okay
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AnnotationSaveModal;
